/* everstory-reskin.js — interactivity for the ported re-skin pages.
   - Tier radios drive the real hidden variant id + CTA label (cart handled by Dawn's <product-form>).
   - Buy-box + FAQ <dl> accordions toggle open/closed.
   Runs on DOMContentLoaded and re-runs on Shopify section load (theme editor). */
(function () {
  // Fire a custom event into Shopify's analytics bus (picked up by the Customer
  // Events custom pixel and forwarded to GA4). No-op if analytics isn't ready.
  //
  // The same call also reaches Meta through everstory-meta.js, which decides for itself whether
  // consent allows it. Meta's own vocabulary is used where one exists (a tier click is a
  // ViewContent); anything else goes over as a custom event, marked with a leading underscore.
  var META = {
    everstory_tier_select: 'ViewContent',
    everstory_addon_add: 'AddToCart',
    everstory_photo_upload: '_PhotoUpload',
    everstory_cta_click: '_CtaClick'
  };

  function track(name, payload) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) {}
    try {
      if (window.esFbq && META[name]) window.esFbq(META[name], payload || {});
    } catch (e) {}
  }

  // The two sibling scripts publish their own events and need the same forwarding.
  window.EverstoryTrack = track;

  function initVariantPicker(root) {
    var picker = root.querySelector('[data-variant-picker]');
    if (!picker) return;
    var idInput = root.querySelector('[data-variant-id]');
    var ctaText = root.querySelector('[data-cta-text]');
    var deliver = root.querySelector('[data-deliver]');

    function apply(radio, isChange) {
      if (!radio) return;
      if (idInput) idInput.value = radio.value;
      root.querySelectorAll('.repl__tier').forEach(function (t) {
        t.classList.toggle('repl__tier--on', t.contains(radio));
      });
      if (ctaText && radio.dataset.cta) ctaText.innerHTML = radio.dataset.cta;
      var turn = (radio.dataset.turnaround || '').trim();
      var prio = (radio.dataset.priority || '').trim();
      var len = (radio.dataset.length || '').trim();
      if (deliver) {
        deliver.innerHTML = turn
          ? 'Delivered in <b>' + turn + '</b>' + (prio ? ' &middot; ' + prio : '')
          : '';
      }
      // Delivery + video-length treatments (everstory-product-shoebox delivery_style).
      root.querySelectorAll('[data-length-out]').forEach(function (el) { el.textContent = len; });
      root.querySelectorAll('[data-deliver-out]').forEach(function (el) { el.textContent = turn; });
      if (isChange) {
        var amount = parseFloat(radio.dataset.amount);
        track('everstory_tier_select', {
          tier: (radio.dataset.cta || radio.value || '').replace(/&rarr;|→/g, '').trim(),
          price: radio.dataset.price || '',
          // Meta reads this one as a ViewContent, and a ViewContent without a number is worth
          // nothing to a value-optimised campaign.
          value: isNaN(amount) ? 0 : amount,
          currency: 'EUR',
          content_type: 'product',
          contents: [{ id: String(radio.value || ''), quantity: 1 }]
        });
      }
    }

    picker.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-variant-radio]');
      if (!radio) return;
      apply(radio, true);
    });
    apply(picker.querySelector('[data-variant-radio]:checked'), false);
  }

  function initCta(root) {
    root.querySelectorAll('.repl__cta').forEach(function (el) {
      if (el.dataset.ctaTracked) return;
      el.dataset.ctaTracked = '1';
      el.addEventListener('click', function () {
        track('everstory_cta_click', {
          text: (el.textContent || '').replace(/&rarr;|→/g, '').trim().slice(0, 80),
          href: el.getAttribute('href') || ''
        });
      });
    });
  }

  // Blog-post CTA tracking. The article body is plain RTE HTML (not a .repl--everstory
  // page), so it needs its own pass. Conversion links carry data-er-cta ("inline"/"footer");
  // we read the post handle off the article wrapper and forward a GA4 click event.
  function initBlogCta(root) {
    var scope = root.querySelector ? root : document;
    scope.querySelectorAll('[data-er-post] [data-er-cta]').forEach(function (el) {
      if (el.dataset.erTracked) return;
      el.dataset.erTracked = '1';
      var wrap = el.closest('[data-er-post]');
      el.addEventListener('click', function () {
        track('everstory_cta_click', {
          post: (wrap && wrap.getAttribute('data-er-post')) || '',
          location: el.getAttribute('data-er-cta') || 'inline',
          text: (el.textContent || '').replace(/&rarr;|→/g, '').trim().slice(0, 80),
          href: el.getAttribute('href') || ''
        });
      });
    });
  }

  // The First Look tray (Session 63). The product placement inside a Journal article: three photo
  // slots the reader fills without leaving the page, then a button that carries the photos to the
  // product page.
  //
  // Two things here are deliberate and easy to undo by accident:
  //
  // 1. ONE state, TWO mounts. The tray renders in the right rail and again inside the prose. Both
  //    read and write the same PHOTOS array, so a photo added in one appears in the other. Give
  //    each mount its own state and a reader fills the rail, scrolls, and meets an empty widget.
  //
  // 2. The prose mount is CLONED from <template data-er-fl-template> over the .er-ctabox that
  //    scripts/lib/render-article.mjs bakes into every post. The 26 already-published articles
  //    therefore pick the tray up with no content re-publish. If a post somehow has no .er-ctabox,
  //    nothing is injected and the rail mount still works.
  //
  // Uploads go to the same Cloudinary unsigned preset assets/everstory-upload.js uses on the
  // product page, and the returned secure_urls are stashed in sessionStorage under FL_KEY, which
  // everstory-upload.js adopts so the reader is not asked for the same files twice. With no
  // cloud/preset configured the tray still works as a local preview and the button still routes
  // to the product page: the widget must never be able to block the conversion.
  var FL_KEY = 'er_firstlook';
  var FL_MAX_BYTES = 10 * 1024 * 1024;   // same per-photo cap as everstory-upload.js
  var PHOTOS = [];                       // [{ id, preview, url }] shared by every mount

  function initFirstLook(root) {
    var scope = root.querySelector ? root : document;
    var article = scope.querySelector ? (scope.querySelector('.er-article') || scope) : scope;

    // Clone the prose mount into the baked-in CTA box before wiring anything up.
    var tpl = scope.querySelector('template[data-er-fl-template]');
    var box = scope.querySelector('.er-prose .er-ctabox');
    if (tpl && box && tpl.content && tpl.content.firstElementChild) {
      box.parentNode.replaceChild(tpl.content.firstElementChild.cloneNode(true), box);
    }

    var mounts = [].slice.call(scope.querySelectorAll('[data-er-fl]'))
      .filter(function (m) { return !m.dataset.erFlReady; });
    if (!mounts.length) return;

    function persist() {
      var urls = PHOTOS.map(function (p) { return p.url; }).filter(Boolean);
      try {
        if (urls.length) sessionStorage.setItem(FL_KEY, JSON.stringify(urls));
        else sessionStorage.removeItem(FL_KEY);
      } catch (e) { /* private mode: the handoff is skipped, the CTA still works */ }
    }

    // Repaint every mount from PHOTOS. Cheap enough to run on any change (3 slots x 2 mounts).
    function render() {
      var n = PHOTOS.length;
      [].slice.call(document.querySelectorAll('[data-er-fl]')).forEach(function (m) {
        [].slice.call(m.querySelectorAll('[data-er-flslot]')).forEach(function (slot, i) {
          var photo = PHOTOS[i];
          var img = slot.querySelector('img');
          if (photo) {
            if (!img) { img = document.createElement('img'); img.alt = ''; slot.insertBefore(img, slot.firstChild); }
            if (img.src !== photo.preview) img.src = photo.preview;
            slot.classList.add('is-done');
            slot.classList.toggle('is-busy', !photo.url && photo.pending);
          } else {
            if (img) img.remove();
            slot.classList.remove('is-done', 'is-busy');
          }
        });
        var count = m.querySelector('[data-er-flcount]');
        if (count) count.textContent = n ? n + ' of 3 added' : '';
        var go = m.querySelector('[data-er-flgo]');
        // The label is the point of the placement: past three photos the reader is not being
        // asked to start something, they are being shown what they already started.
        if (go) {
          go.textContent = n >= 3 ? 'See my First Look →'
            : n > 0 ? 'Continue with ' + n + ' photo' + (n === 1 ? '' : 's') + ' →'
              : (go.getAttribute('data-label') || 'Start your free First Look');
        }
      });
      persist();
    }

    function fail(msg) {
      [].slice.call(document.querySelectorAll('[data-er-flerr]')).forEach(function (el) {
        el.textContent = msg || '';
        el.hidden = !msg;
      });
    }

    function add(file, mount) {
      if (PHOTOS.length >= 3) { fail('Three photos is the free First Look. Send the rest with your full reel.'); return; }
      if (!/^image\//.test(file.type)) { fail('That file is not an image.'); return; }
      if (file.size > FL_MAX_BYTES) { fail('Photos need to be under 10MB.'); return; }
      fail('');

      var photo = { preview: URL.createObjectURL(file), url: '', pending: true };
      PHOTOS.push(photo);
      render();

      var cloud = (mount.dataset.cloud || '').trim();
      var preset = (mount.dataset.preset || '').trim();
      if (!cloud || !preset) { photo.pending = false; photo.url = ''; render(); return; }

      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', preset);
      fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/upload',
        { method: 'POST', body: fd })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
        .then(function (j) {
          photo.pending = false;
          photo.url = j.secure_url || '';
          // The same event the buy box raises (ADR-019). A reader who puts photographs into a
          // Journal article has shown the intent the funnel is read on, and this tray produced no
          // count of any kind before 2026-08-20.
          if (photo.url && window.esHit) window.esHit('upload_done');
          render();
        })
        .catch(function () {
          var i = PHOTOS.indexOf(photo);
          if (i !== -1) PHOTOS.splice(i, 1);
          render();
          fail('That upload did not go through. Check your connection and try again.');
        });
    }

    function remove(i) {
      var photo = PHOTOS[i];
      if (!photo) return;
      try { URL.revokeObjectURL(photo.preview); } catch (e) {}
      PHOTOS.splice(i, 1);
      render();
    }

    mounts.forEach(function (mount) {
      mount.dataset.erFlReady = '1';
      var input = mount.querySelector('[data-er-flinput]');
      if (!input) return;

      [].slice.call(mount.querySelectorAll('[data-er-flslot]')).forEach(function (slot, i) {
        function open() { if (PHOTOS.length < 3) input.click(); }
        slot.addEventListener('click', open);
        slot.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); open(); }
        });
        var x = slot.querySelector('.x');
        if (x) x.addEventListener('click', function (ev) { ev.stopPropagation(); remove(i); });
      });

      input.addEventListener('change', function () {
        var picked = [].slice.call(input.files || []);
        var room = 3 - PHOTOS.length;
        picked.slice(0, room).forEach(function (f) { add(f, mount); });
        // Say so when files were dropped for want of room. Trimming to `room` first means add()
        // never sees the overflow, so without this the extras vanish without a word. It has to
        // come AFTER the adds: every successful add() clears the message.
        if (picked.length > room) {
          fail('Three photos is the free First Look. Send the rest with your full reel.');
        }
        input.value = '';
      });

      // The showcase reel is preload="none" until it is worth the bytes.
      var stage = mount.querySelector('.er-flstage video');
      if (stage && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (!e.isIntersecting) return;
              stage.preload = 'auto';
              stage.muted = true;
              stage.play().catch(function () {});
              io.unobserve(e.target);
            });
          }, { threshold: 0.25 });
          io.observe(stage);
        } else {
          stage.preload = 'auto';
          stage.muted = true;
          stage.play().catch(function () {});
        }
      }
    });

    if (article) render();
  }

  // The proof clip under an article's TL;DR (2026-09-15). preload="none" until it is on screen, and
  // only where it is shown at all: the block is display:none above 900px, so desktop never fetches it.
  function initProof(scope) {
    var v = scope.querySelector('[data-er-proof]');
    if (!v || v.dataset.erProofInit) return;
    v.dataset.erProofInit = '1';
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function play() { v.preload = 'auto'; v.muted = true; v.play().catch(function () {}); }
    if (!('IntersectionObserver' in window)) { if (v.offsetParent) play(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || !v.offsetParent) return;
        play();
        io.unobserve(e.target);
      });
    }, { threshold: 0.25 });
    io.observe(v);
  }

  // Journal article contents rail. The article body is published HTML, so the rail is built at
  // runtime from the h2 ids the renderer emits (scripts/lib/render-article.mjs slugifyHead()).
  // Two copies of the list: the sticky left rail on desktop, and a collapsed <details> for the
  // narrow widths where that rail is hidden. A post with fewer than two sections gets neither.
  function initArticleToc(root) {
    var scope = root.querySelector ? root : document;
    scope.querySelectorAll('.er-article').forEach(function (art) {
      if (art.dataset.erTocReady) return;
      art.dataset.erTocReady = '1';

      var rail = art.querySelector('[data-er-toc]');
      var mob = art.querySelector('[data-er-tocm]');
      var tops = Array.prototype.slice.call(art.querySelectorAll('.er-prose h2[id]'));
      // The page does not end at the last prose heading, so the FAQ and the related list belong
      // in the rail too. Otherwise the reader is told the article is over one section early.
      ['.er-faq h2[id]', '.er-related h2[id]'].forEach(function (sel) {
        var el = art.querySelector(sel);
        if (el) tops.push(el);
      });
      if (tops.length < 2) return;

      // Every h3 between one h2 and the next is a child of that h2.
      var heads = [];
      tops.forEach(function (h2, i) {
        var kids = [];
        for (var n = h2.nextElementSibling; n; n = n.nextElementSibling) {
          if (n.tagName === 'H2') break;
          if (n.tagName === 'H3' && n.id) kids.push(n);
        }
        heads.push({ el: h2, kids: kids, last: i === tops.length - 1 });
      });

      function link(h, sub) {
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = (h.textContent || '').trim();
        a.dataset.erTocLink = h.id;
        if (sub) a.className = 'er-sub-link';
        return a;
      }
      function build(target) {
        heads.forEach(function (g) {
          var wrap = document.createElement('div');
          wrap.className = 'er-grp';
          wrap.dataset.erGrp = g.el.id;
          wrap.appendChild(link(g.el));
          if (g.kids.length) {
            var sub = document.createElement('div');
            sub.className = 'er-sub';
            g.kids.forEach(function (k) { sub.appendChild(link(k, true)); });
            wrap.appendChild(sub);
          }
          target.appendChild(wrap);
        });
      }
      if (rail) {
        build(rail);
        rail.hidden = false;
      }
      if (mob) {
        var list = mob.querySelector('.er-toclist') || mob;
        build(list);
        mob.hidden = false;
        // Read order is TL;DR first, then contents. The TL;DR ships inside the published body,
        // so the accordion is moved into place rather than authored there.
        var tldr = art.querySelector('.er-tldr');
        if (tldr && tldr.parentNode) tldr.parentNode.insertBefore(mob, tldr.nextSibling);
      }

      if (!rail) return;
      var links = Array.prototype.slice.call(rail.querySelectorAll('[data-er-toc-link]'));
      var groups = Array.prototype.slice.call(rail.querySelectorAll('.er-grp'));
      // Flat list of every heading in document order, parents and children alike.
      var flat = [];
      heads.forEach(function (g) { flat.push(g.el); g.kids.forEach(function (k) { flat.push(k); }); });

      // The active heading is the LAST one that has passed the top of the read, not whichever
      // heading happens to be inside an observer band. A section taller than the band would
      // otherwise leave the rail with nothing highlighted for most of the time spent reading it.
      function sync() {
        var current = flat[0].id;
        for (var i = 0; i < flat.length; i++) {
          if (flat[i].getBoundingClientRect().top <= 120) current = flat[i].id;
          else break;
        }
        links.forEach(function (a) { a.classList.toggle('is-on', a.dataset.erTocLink === current); });
        // Open only the section being read, so the rail stays short.
        groups.forEach(function (g) {
          g.classList.toggle('is-open', !!g.querySelector('.is-on'));
        });
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; sync(); });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      sync();
    });
  }

  // Journal index: topic-family chips filter the card grid in place. Client-side because the
  // whole post list ships in one page (see the paginate limit in sections/main-blog.liquid).
  function initBlogFilter(root) {
    var scope = root.querySelector ? root : document;
    scope.querySelectorAll('[data-er-chips]').forEach(function (bar) {
      if (bar.dataset.erChipsReady) return;
      bar.dataset.erChipsReady = '1';
      var wrap = bar.closest('.er-blog') || document;
      var cards = Array.prototype.slice.call(wrap.querySelectorAll('[data-er-family]'));
      var empty = wrap.querySelector('[data-er-empty]');
      bar.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-er-chip]');
        if (!chip) return;
        var pick = chip.getAttribute('data-er-chip');
        bar.querySelectorAll('[data-er-chip]').forEach(function (c) {
          c.classList.toggle('is-on', c === chip);
        });
        var shown = 0;
        cards.forEach(function (card) {
          var hit = pick === 'all' || card.getAttribute('data-er-family') === pick;
          card.hidden = !hit;
          if (hit) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
  }

  function initAccordions(root) {
    root.querySelectorAll('.repl__pacc, .repl__faq').forEach(function (dl) {
      dl.querySelectorAll('dt').forEach(function (dt) {
        dt.setAttribute('role', 'button');
        dt.setAttribute('tabindex', '0');
        function toggle() {
          dt.classList.toggle('is-open');
        }
        dt.addEventListener('click', toggle);
        dt.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            toggle();
          }
        });
      });
    });
  }

  function initGallery(root) {
    var gal = root.querySelector('[data-er-gallery]');
    if (!gal || gal.dataset.galReady) return;

    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-g-slide]'));
    var dots = Array.prototype.slice.call(gal.querySelectorAll('.repl__gdots i'));
    if (!slides.length) return;
    gal.dataset.galReady = '1';
    var cur = 0;

    function stop(slide) {
      var frame = slide.querySelector('[data-g-frame]');
      if (!frame) return;
      frame.classList.remove('is-playing');
      var v = frame.querySelector('video');
      if (v) { try { v.pause(); v.currentTime = 0; } catch (e) {} }
    }
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-on', n === cur);
        if (n !== cur) stop(s);
      });
      dots.forEach(function (d, n) { d.classList.toggle('on', n === cur); });
    }
    function play(frame) {
      var v = frame.querySelector('video');
      if (!v) return;
      frame.classList.add('is-playing');
      try { v.play(); } catch (e) {}
    }

    slides.forEach(function (slide) {
      var frame = slide.querySelector('[data-g-frame]');
      if (!frame) return;
      var v = frame.querySelector('video');
      frame.querySelectorAll('[data-g-play]').forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); play(frame); });
      });
      if (v) {
        v.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
        v.addEventListener('ended', function () { frame.classList.remove('is-playing'); v.currentTime = 0; });
      }
    });

    gal.querySelectorAll('.repl__garrow--l').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(cur - 1); });
    });
    gal.querySelectorAll('.repl__garrow--r').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(cur + 1); });
    });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
    show(0);
  }

  function initVideoShow(root) {
    root.querySelectorAll('[data-er-vshow]').forEach(function (show) {
      if (show.dataset.vshowReady) return;
      show.dataset.vshowReady = '1';
      var main = show.querySelector('[data-v-main]');
      var video = main && main.querySelector('video');
      var thumbs = Array.prototype.slice.call(show.querySelectorAll('[data-v-thumb]'));
      if (!video || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          if (t.classList.contains('is-on')) return;
          thumbs.forEach(function (o) { o.classList.toggle('is-on', o === t); });
          main.classList.add('is-swapping'); // fade the current frame out
          var t0 = Date.now();
          var reveal = function () { // keep faded for >=180ms so the crossfade always shows
            setTimeout(function () { main.classList.remove('is-swapping'); }, Math.max(0, 180 - (Date.now() - t0)));
          };
          var html = '';
          if (t.dataset.mp4) html += '<source src="' + t.dataset.mp4 + '" type="video/mp4">';
          if (t.dataset.webm) html += '<source src="' + t.dataset.webm + '" type="video/webm">';
          video.innerHTML = html;
          if (t.dataset.poster) video.poster = t.dataset.poster;
          video.load();
          video.addEventListener('loadeddata', reveal, { once: true });
          setTimeout(reveal, 450); // fallback if loadeddata is missed
          try { video.play(); } catch (e) {}
        });
      });
    });
  }

  function initLadder(root) {
    root.querySelectorAll('[data-pick-variant]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var radio = root.querySelector('[data-variant-radio][value="' + link.getAttribute('data-pick-variant') + '"]');
        if (!radio || radio.disabled) return; // let the ?variant= href handle it
        e.preventDefault();
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        var target = root.querySelector('.repl__tiers') || root.querySelector('product-form');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  // Reviews carousel (shoebox page). Transform-based track, dots, arrows, swipe, auto-advance.
  function initReviewCarousel(root) {
    root.querySelectorAll('[data-er-revcar]').forEach(function (car) {
      if (car.dataset.revcarReady) return;
      var track = car.querySelector('[data-revcar-track]');
      var slides = Array.prototype.slice.call(car.querySelectorAll('.repl__revcar-slide'));
      if (!track || slides.length < 2) return;
      car.dataset.revcarReady = '1';
      var dotsWrap = car.querySelector('[data-revcar-dots]');
      var cur = 0, timer = null;

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (s, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'repl__revcar-dot';
          b.setAttribute('aria-label', 'Review ' + (i + 1));
          b.addEventListener('click', function () { go(i, true); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function render() {
        track.style.transform = 'translateX(' + (-cur * 100) + '%)';
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === cur); });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === cur); });
      }
      function go(i, user) { cur = (i + slides.length) % slides.length; render(); if (user) restart(); }
      function next() { go(cur + 1); }
      function prev() { go(cur - 1); }
      function start() { if (!timer) timer = setInterval(next, 5000); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      car.querySelectorAll('[data-revcar-next]').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1, true); }); });
      car.querySelectorAll('[data-revcar-prev]').forEach(function (b) { b.addEventListener('click', function () { go(cur - 1, true); }); });
      car.addEventListener('mouseenter', stop);
      car.addEventListener('mouseleave', start);
      car.addEventListener('focusin', stop);
      car.addEventListener('focusout', start);

      var x0 = null;
      var vp = car.querySelector('.repl__revcar-vp') || track;
      vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      vp.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); }
        x0 = null; start();
      });

      render();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) start();
    });
  }

  /**
   * The offer bar: the only offer a visitor who never scrolls can see.
   *
   * WHY IT EXISTS is measured in snippets/everstory-offer-bar.liquid. In short: 68 of 77 paid
   * visitors never scrolled the 703px that brings the Add to Cart button into view, so for 88% of
   * paid traffic this page carried no price and no button at all.
   *
   * THREE THINGS IT HAS TO GET RIGHT, and each of them is a real failure if it does not:
   *
   *   It may never cover the buy box it points at. Once the real Add to Cart is on screen the bar
   *   has done its job and hides, so the tier ladder and the uploader are never behind it.
   *
   *   It may never cover Shopify's consent banner, which is fixed at z-index 2000000 and is the one
   *   thing on the page a visitor MUST be able to answer. A double banner covering the phone from
   *   431px down is what produced 94 fb-ads sessions with zero cart additions on 08-17/18. So the
   *   bar measures the banner and lifts itself clear of it rather than stacking on it.
   *
   *   Pressing "Start free" has to produce the free tier. The ad arrives with ?variant= on the
   *   cheapest PAID tier, and scrolling to a €39 selection after that press would be a bait.
   */
  function initOfferBar(root) {
    var bar = root.querySelector('[data-er-offer-bar]');
    if (!bar || bar.dataset.erObarReady) return;
    bar.dataset.erObarReady = '1';

    var target = root.querySelector(bar.getAttribute('data-target') || '#everstory-product-form');
    var realCta = root.querySelector('[data-add-btn]');
    var freeId = bar.getAttribute('data-free-variant');

    function sync() {
      // Hidden while the real CTA is on screen, and while the page is still at the very top the bar
      // is the point, so it shows immediately rather than waiting for a scroll.
      var onScreen = false;
      if (realCta) {
        var r = realCta.getBoundingClientRect();
        onScreen = r.top < window.innerHeight && r.bottom > 0;
      }
      bar.hidden = onScreen;

      // The consent banner is rendered by Shopify a moment after load and removed when answered, so
      // its height is read every time rather than once.
      var banner = document.getElementById('shopify-pc__banner');
      var lift = 0;
      if (banner) {
        var b = banner.getBoundingClientRect();
        if (b.height && b.bottom > window.innerHeight - 4) lift = Math.round(b.height);
      }
      bar.style.setProperty('--es-obar-lift', lift + 'px');
    }

    bar.querySelector('[data-er-offer-go]').addEventListener('click', function () {
      if (window.esHit) window.esHit('offer_bar_click');
      // Select the free tier through its own radio, so the variant picker's change handler does the
      // rest: the hidden id input, the tier highlight, the CTA label, the uploader's photo cap and
      // the Meta value all move together. Setting the id input directly would leave all of them.
      var radio = freeId && root.querySelector('[data-variant-radio][value="' + freeId + '"]');
      if (radio && !radio.checked && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sync(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // The banner arrives late and leaves on a click, and neither raises an event this can listen to.
    var polls = 0;
    var poll = setInterval(function () { sync(); if (++polls > 30) clearInterval(poll); }, 500);
    sync();
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('.repl--everstory').forEach(function (page) {
      initOfferBar(page);
      initVariantPicker(page);
      initAccordions(page);
      initGallery(page);
      initVideoShow(page);
      initLadder(page);
      initReviewCarousel(page);
      initCta(page);
    });
    // First: it clones the prose mount in, and initBlogCta has to see that mount's CTA link.
    initFirstLook(root);
    initProof(root);
    initArticleToc(root);
    initBlogFilter(root);
    initBlogCta(root);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
